export default [
  {
    index: 0,
    name: '服务支持',
    isSubShow: false,
    arrow: '',
    children: [
      {
        index: 0,
        name: '手机搬家',
        url: 'https://www.coloros.com/index/clonephone'
      },
      {
        index: 1,
        name: '使用手册',
        url: 'https://www.coloros.com/instruction'
      },
      {
        index: 2,
        name: '自助服务',
        url: 'https://www.oppo.com/cn/service.html'
      },
      {
        index: 3,
        name: '线下体验店',
        url: 'https://www.oppo.com/cn/shops'
      },
      {
        index: 4,
        name: '安全响应中心',
        url: 'https://security.oppo.com/'
      }
    ]
  },
  {
    index: 1,
    name: '商务合作',
    isSubShow: false,
    arrow: '',
    children: [
      {
        index: 0,
        name: '开放平台',
        url: 'http://open.oppomobile.com'
      },
      {
        index: 1,
        name: '广告联盟',
        url: 'https://u.oppomobile.com/'
      },
      {
        index: 2,
        name: '营销平台',
        url: 'https://e.oppomobile.com/'
      }
    ]
  },
  {
    index: 2,
    name: '新闻资讯',
    isSubShow: false,
    arrow: '',
    children: [
      {
        index: 0,
        name: '新闻动态',
        url: 'https://www.coloros.com/index/news.html'
      },
      {
        index: 1,
        name: '官方视频',
        url: 'https://space.bilibili.com/402713073?from=search&amp;seid=9286174685923568465'
      }
    ]
  },
  {
    index: 3,
    name: '其他官方网站',
    isSubShow: false,
    arrow: '',
    children: [
      {
        index: 0,
        name: 'OPPO 官网',
        url: 'https://www.oppo.com/cn/'
      },
      {
        index: 1,
        name: 'realme官网',
        url: 'https://www.realme.com'
      },
      {
        index: 2,
        name: '软件商店',
        url: 'http://store.oppomobile.com'
      },
      {
        index: 3,
        name: '官方商城',
        url: 'https://www.opposhop.cn'
      },
      {
        index: 4,
        name: '预置软件公示',
        url: 'https://www.coloros.com/presoftware/index.html'
      }
    ]
  }
];
